import { render, staticRenderFns } from "./UploadModelFile.vue?vue&type=template&id=4232c6a8&"
import script from "./UploadModelFile.vue?vue&type=script&lang=js&"
export * from "./UploadModelFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports